// extracted by mini-css-extract-plugin
module.exports = {"header":"Content_style_header__qZaCM","date":"Content_style_date__1PPfv"};